'use client'

import Script from 'next/script'

export const ReclameAquiBadge = () => {
  return (
    <div id="reputation-ra">
      <Script
        defer
        type="text/javascript"
        id="ra-embed-reputation"
        src="https://s3.amazonaws.com/raichu-beta/selos/bundle.js"
        data-id="WkJmTDFVd1FuQVVreW1kaDp0cmVldW5mZS1pbmZvcm1hdGljYQ=="
        data-target="reputation-ra"
        data-model="2"
      />
    </div>
  )
}
